import type { components } from '@/types/api-schema';

export type EventStatusType = components['schemas']['EventStatus'];

/**
 * 各ステータスの定数
 *
 * `satisfies` の型に mapped type を使うことで、SSOT（OpenAPI 生成型）に新しい
 * EventStatus 値が追加された際に、このオブジェクトの項目不足がコンパイルエラーとして
 * 検出される。キー名は値の uppercase と一致させる必要がある。
 */
export const EVENT_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
} as const satisfies { [K in EventStatusType as Uppercase<K>]: K };

// ステータスの日本語ラベル
export const EVENT_STATUS_LABEL: Record<EventStatusType, string> = {
  [EVENT_STATUS.DRAFT]: '下書き',
  [EVENT_STATUS.PUBLISHED]: '公開中',
  [EVENT_STATUS.CANCELLED]: '中止',
  [EVENT_STATUS.COMPLETED]: '終了',
};

/**
 * ステータスの日本語ラベルを取得（未定義ステータスは「不明」を返す）
 */
export function getEventStatusLabel(status: string): string {
  return EVENT_STATUS_LABEL[status as EventStatusType] ?? '不明';
}

// すべてのステータス
export const EVENT_STATUSES: EventStatusType[] = [
  EVENT_STATUS.DRAFT,
  EVENT_STATUS.PUBLISHED,
  EVENT_STATUS.CANCELLED,
  EVENT_STATUS.COMPLETED,
];
